import { Paper, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Dayjs } from "dayjs";
import PerformanceFilterItems from "./PerformanceFilterItems";

interface PerformanceFilterCardProps {
  dateRange: [Dayjs | null, Dayjs | null];
  onDateRangeChange: (range: [Dayjs | null, Dayjs | null]) => void;
}

export default function PerformanceFilterCard({ dateRange, onDateRangeChange }: PerformanceFilterCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: "18px 22px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2.25,
        borderColor: "#ececec",
      }}
    >
      <PerformanceFilterItems dateRange={dateRange} onDateRangeChange={onDateRangeChange} />
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ ml: "auto", color: "#9e9e9e" }}
      >
        <InfoOutlinedIcon fontSize="small" sx={{ color: "#8E24AA", fontSize: 16 }} />
        <Typography variant="caption" sx={{ fontSize: 13 }}>
          Account Summary - powered by BQL
        </Typography>
      </Stack>
    </Paper>
  );
}
